import { FontWeights, IButtonStyles, IconButton, mergeStyleSets, Modal } from '@fluentui/react';
import { useEffect, useState } from 'react';

import { cancelIcon } from '../../../../../utils/icons';
import { theme } from '../../../../../utils/theme';
import SelectAccount from '../../../../Accounts/SelectAccount';
import { actions, useFormSelector } from '../../../slice';

export default () => {
  const isModalOpen = !!useFormSelector((state) => state.isAccountModalOpen);
  const setModalOpen = (bool: boolean) => {
    actions.setFormVariable(["isAccountModalOpen", bool]);
  };
  const toggleModal = () => setModalOpen(!isModalOpen);

  return (
    <Modal
      isOpen={isModalOpen}
      isBlocking={true}
      styles={{
        main: { width: "40%", minWidth: "800px", overflowY: "none" },
      }}
    >
      <div className={contentStyles.container}>
        <div className={contentStyles.header}>
          <span>Müşteri Ekle</span>
          <IconButton
            styles={iconButtonStyles}
            iconProps={cancelIcon}
            onClick={toggleModal}
          />
        </div>
        <div className={contentStyles.body}>
          <SelectAccount isFullWidth noReset />
        </div>
      </div>
    </Modal>
  );
};

const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 24px",
    },
  ],
  body: {
    minHeight: "55vh",
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    overflowY: "hidden",
  },
});
const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};
